import { Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

export interface ConfirmModel {
  title: string;
  message: string;
}

export interface ConfirmResult {
  confirmed: boolean;
  message: string;
}

@Component({
  selector: 'app-confirm',
  imports: [],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.css'
})
export class ConfirmComponent extends DialogComponent<ConfirmModel, ConfirmResult> implements ConfirmModel {
  title: string = '';
  message: string = '';

  constructor(dialogService: DialogService){
    super(dialogService);
  }

  confirm() {
    this.result = { confirmed: true, message: this.message };
    this.close();
  }

  cancel() {
    this.result = { confirmed: false, message: '' };
    this.close();
  }

}
